module.exports = __webpack_public_path__ + "img/bepreisung_1.509ac1a9.png";